import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialogViewModel from "./../factories/bao-dialog";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
function SoftwareViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(SoftwareViewModel, SearchPaging);
SoftwareViewModel.prototype.PrimaryKey = "SoftwareId";
SoftwareViewModel.prototype.RefreshUrl = "Software/Get";
SoftwareViewModel.prototype.SaveUrl = "Software/Save";
SoftwareViewModel.prototype.DeleteUrl = "Software/Delete";
SoftwareViewModel.prototype.IsInUseUrl = "Software/IsInUse";
SoftwareViewModel.prototype.PermissionForward = "SoftwareProductMoveForwardSearch";
SoftwareViewModel.prototype.PermissionBackward = "SoftwareProductMoveBackwardSearch";
SoftwareViewModel.prototype.PermissionSave = "SoftwareProductSave";
SoftwareViewModel.prototype.PermissionRefresh = "SoftwareProductRefresh";
SoftwareViewModel.prototype.PermissionDelete = "SoftwareProductDelete";
export default SoftwareViewModel;